module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "dedication",
      "id": "ded",
      "role": "doc-dedication"
    }
  }, [_c('p', {
    staticClass: "dedf"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "v",
      "id": "pv",
      "role": "doc-pagebreak"
    }
  }), _vm._v("To my aunt Pat Stephens (1931–2019), who always encouraged me, and more than earned her spot in the Good Place.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-176576bf","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/wsu-tvmgoodplace-0007.vue
// module id = 72
// module chunks = 0